export default __webpack_public_path__ + "static/media/vp_hotel_resort.4c1986d1.svg";